import helperFunctions from "@/components/RenderedDie/shaders/helperFunctions.frag";
import { shaderMaterial } from "@react-three/drei";
import { extend } from "@react-three/fiber";
import { Matrix4 } from "three";

export const MistMaterial = shaderMaterial(
  {
    iGlobalTime: 0.0,
    u_Matrix: new Matrix4(),
    u_Scale: 0.7,
    u_ScaleOverride: 35.0, // amplify the animated scale
    u_empty: 0.0,
    u_Vector: [1.75, 0.0, 4.15],
    u_Speed: 1.0,
    u_Alpha: 0.0,
    u_Removal: 0.0,
    TextureTexture: null,
    textureInfoName: 1.0,
  },
  `
    precision highp float;

    uniform mat4 u_Matrix;
    uniform float u_Scale;
    uniform float u_ScaleOverride;
    uniform float u_empty;
    uniform vec3 u_Vector;
    uniform float iGlobalTime;
    uniform float u_Speed;

    varying vec2 vUv2;
    varying float v_y1;

    void main() {
      vec3 pos = position;
      vec4 transformedPos = u_Matrix * vec4(pos, 1.0);
      vec3 xyz3 = transformedPos.xyz * u_Scale * u_ScaleOverride;

      xyz3 += u_Vector;

      vec4 mvPosition = modelViewMatrix * vec4(xyz3, 1.0);
      gl_Position = projectionMatrix * mvPosition;

      // UV animation
      float t = iGlobalTime * u_Speed;
      float x1 = uv.x;
      float y1 = uv.y;
      float output6 = t + x1;

      vUv2 = vec2(output6, y1);
      v_y1 = y1;
    }
  `,
  `
    precision highp float;

    uniform sampler2D TextureTexture;
    uniform float u_Alpha;
    uniform float u_Removal;
    uniform float textureInfoName;

    varying vec2 vUv2;
    varying float v_y1;

    ${helperFunctions}

    void main() {
      vec4 tex = texture2D(TextureTexture, vUv2);

      vec3 rgb = tex.rgb * textureInfoName;
      #ifdef ISGAMMA1
        rgb = toLinearSpace(rgb);
      #endif
      float a = tex.a * textureInfoName;

      float output8 = a * u_Alpha;

      vec4 color = vec4(rgb, output8);

      #ifdef CONVERTTOLINEAR0
        color = toLinearSpace(color);
      #endif
      #ifdef CONVERTTOGAMMA0
        color = toGammaSpace(color);
      #endif

      // Vertical removal based on UV.y
      float output10 = 1.0 - v_y1;
      float output9 = abs(output10);

      if (output9 < u_Removal) {
        discard;
      }

      gl_FragColor = color;
    }
  `,
);

extend({ MistMaterial });
